import ProgressStar from './ProgressStar';
export default ProgressStar;
